import { Tool } from '../../types';

export const freelanceTools: Tool[] = [
  {
    id: 'bonsai',
    name: 'Bonsai',
    category: 'Freelance Management',
    description: 'All-in-one freelance business management platform',
    pricing: ['medium'],
    features: ['invoicing', 'automation', 'document-management'],
    bestFor: ['freelancer', 'solopreneur'],
    compatibleWith: ['service-business', 'consulting'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['creative', 'consulting', 'technology'],
    website: 'https://www.hellobonsai.com',
    imageUrl: 'https://logo.clearbit.com/hellobonsai.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  },
  {
    id: 'dubsado',
    name: 'Dubsado',
    category: 'Client Management',
    description: 'Business management solution with client workflows',
    pricing: ['medium'],
    features: ['automation', 'invoicing', 'document-management'],
    bestFor: ['freelancer', 'solopreneur'],
    compatibleWith: ['service-business', 'consulting'],
    goals: ['streamline-operations', 'automate-tasks'],
    industries: ['creative', 'consulting'],
    website: 'https://www.dubsado.com',
    imageUrl: 'https://logo.clearbit.com/dubsado.com',
    idealStages: ['launching', 'growing'],
    technicalLevel: ['beginner', 'intermediate'],
    minTeamSize: 'solo'
  }
];